import { render, staticRenderFns } from "./PromocionModal.vue?vue&type=template&id=2e1f1787&scoped=true&"
import script from "./PromocionModal.vue?vue&type=script&lang=js&"
export * from "./PromocionModal.vue?vue&type=script&lang=js&"
import style0 from "./PromocionModal.vue?vue&type=style&index=0&id=2e1f1787&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f1787",
  null
  
)

export default component.exports